module.exports = __webpack_public_path__ + "static/media/COSCO.a3dd34c0.svg";